import { GeneratedSignerLayout } from '../generated/domain-models/generated-signer-layout';

export class SignerLayout extends GeneratedSignerLayout {

}
